import { BaseViewStore } from "core/stores";
import { action, observable } from "mobx";
import { PatientMissingDocsTemplateEditViewStore } from "application/patient-missing-docs/stores";

class PatientMissingDocsEditViewStore extends BaseViewStore {
    @observable accessor item;
    @observable accessor facilityOrderTemplateStore;
    @observable accessor pastFacilityOrderTemplateStores;
    @observable accessor isPastDosVisible;
    @observable accessor showOnlyCheckedPastTemplates = false;
    
    constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.id = componentsProps.id;
        this.missingDocuments = componentsProps.missingDocuments;
        this.lookups = componentsProps.lookups;
        this.latestFacilityOrderId = componentsProps.latestFacilityOrderId;
        this.facilityOrderPatients = componentsProps.facilityOrderPatients;

        this.fetch([this.initialize(componentsProps.item)]);
    }

    @action.bound
    async initialize(items) {
        if (items && items.length > 0) {
            this.item = items[0];
            this.facilityOrderTemplateStore = new PatientMissingDocsTemplateEditViewStore(this.rootStore, { id: this.item.id, item: this.item, missingDocuments: this.missingDocuments, lookups: this.lookups, latestFacilityOrderId: this.latestFacilityOrderId, eligibilityStatus: this.facilityOrderPatients && this.facilityOrderPatients.find(x=> x.facilityOrderId == this.item.facilityOrderId) && this.facilityOrderPatients.find(x=> x.facilityOrderId == this.item.facilityOrderId).eligibilityStatus });

            let pastFacilityOrderTemplates = items.filter(x => x.id !== this.item.id);
            if (pastFacilityOrderTemplates && pastFacilityOrderTemplates.length > 0) {
                this.pastFacilityOrderTemplateStores = pastFacilityOrderTemplates.map(item =>
                    new PatientMissingDocsTemplateEditViewStore(this.rootStore, { id: item.id, item: item, missingDocuments: this.missingDocuments, lookups: this.lookups, latestFacilityOrderId: this.latestFacilityOrderId, eligibilityStatus: this.facilityOrderPatients && this.facilityOrderPatients.find(x=> x.facilityOrderId == item.facilityOrderId) && this.facilityOrderPatients.find(x=> x.facilityOrderId == item.facilityOrderId).eligibilityStatus })
                );

                this.isPastDosVisible = pastFacilityOrderTemplates.some(x=> x.includeInDocReqEmail);
                this.showOnlyCheckedPastTemplates = this.isPastDosVisible;
            }
        }
    }

    @action.bound
    changePastDosVisiblity() {
        this.isPastDosVisible = !this.isPastDosVisible;
    }

    @action.bound
    setShowOnlyCheckedPastTemplates() {
        this.showOnlyCheckedPastTemplates = !this.showOnlyCheckedPastTemplates;
    }
}

export default PatientMissingDocsEditViewStore;
